
import { Router } from "@angular/router";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, forkJoin } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { CustomSnackBarService } from "src/app/shared/components/custom-snack-bar/custom-snack-bar.service";
import { AESService } from "src/app/shared/components/aes/aesservice";
import { environment } from "src/environments/environment";
import { AuthRequest } from "src/app/models/auth/auth-request";
import { AuthData } from "src/app/models/auth/auth-data";
import { AbstractIdbaRequestModel } from "src/app/shared/models/abstract-idba-request-model";
import { MenuItemButton } from "src/app/shared/components/sidemenu/models/buttons/menu-item-button";
import { JwtHelperService } from "@auth0/angular-jwt";
import { SESSION_STORAGE, StorageService } from "ngx-webstorage-service";
import { ParametrosGenericosService } from "../bas/parametros-genericos.service";
import { RelacaoGenericaService } from "../bas/relacao-generica.service";


@Injectable({
  providedIn: "root",
})

export class AuthService {
  private loggedIn = new BehaviorSubject<boolean>(false);

  private readonly jwtTokenName = "authERP";
  private readonly jwtTokenMenu = "menuERP";

  loggedUserName: string;
  loggedUserId: number;
  loggedUserType: Number;
  loggedUserEmail: string;
  loggedEmpresaUser: number;
  loggedNomeEmpresaUser: string;
  rowidLoggedUser: string;

  authData: AuthData;

  active: Boolean;
  loggedTime: Date;
  tokenApp: string | undefined;
  tokenBackEnd: string | undefined;

  constructor(
    private router: Router,
    private http: HttpClient,
    private snackBar: CustomSnackBarService,
    private aesService: AESService,
    private parametroGenericoService: ParametrosGenericosService,
    private relacaoGenericaService: RelacaoGenericaService,
    @Inject(SESSION_STORAGE) private storage: StorageService,

  ) {
    var token: string = localStorage.getItem(this.jwtTokenName) as string;
    if (token) {

      if (environment.production) {
        try {
          token = this.aesService.decrypt(token);
        }
        catch {
          this.snackBar.openSnackBar("Sessão Inválida!", "error");
          this.logout("",true);
          return;
        }
      }
      else {
        if (!this.IsJsonString(token)) {
          this.snackBar.openSnackBar("Sessão Inválida!", "error");
          this.logout("",true);
          return;
        }
      }

      this.authData = new AuthData(JSON.parse(token));

      this.loggedUserName = this.authData.nomeUsuario;
      this.loggedUserId = this.authData.codigoUsuario;
      this.loggedUserType = this.authData.indTipoUsuario;
      this.active = this.authData.indAtivo;
      this.loggedTime = this.authData.dataHoraLogin;
      this.loggedUserEmail = this.authData.emailUsuario;
      this.loggedEmpresaUser = this.authData.codigoEmpresa;
      this.loggedNomeEmpresaUser = this.authData.nomeEmpresa;
      this.tokenApp = this.authData.tokenApp;
      this.tokenBackEnd = this.authData.tokenBackEnd;
      this.rowidLoggedUser = this.authData.rowid;
      this.loggedIn.next(true);
    }
  }

  login(authRequest: AuthRequest) {
    authRequest.password = this.aesService.encrypt(authRequest.password)
    return this.http.post<any>(environment.apiURLLogin, authRequest, { observe: 'response' });
  }

  atualizaUsuarioLogado(authData: AuthData) {
    this.setSession(authData); 
    this.carregaParametros(authData, this);
  }

  atualizaParametros()
  {
    this.carregaParametros(this.authData, this);
  }

  carregaParametros(authData: AuthData, authService: AuthService) {

    forkJoin([this.parametroGenericoService.listAll(),
              this.relacaoGenericaService.listarRelacaoGenericaPorUsuario(),
      ]).subscribe(([parametroGenerico, relacaoGenerica]) => {
      
      authData["PR"] = {};

      authData["RG"] = {};

      for (let index = 0; index < relacaoGenerica?.body?.retorno?.registro?.length; index++) {
        const element = relacaoGenerica.body.retorno.registro[index];

        if (!authData["RG"][element.assunto])
          authData["RG"][element.assunto] = {};
        if (!authData["RG"][element.assunto][element.codigo])
          authData["RG"][element.assunto][element.codigo] = {};
          
        authData["RG"][element.assunto][element.codigo] = element.valor;
      }

      parametroGenerico.forEach(element => {
        if (!authData["PR"][element.abrevModulo])
          authData["PR"][element.abrevModulo] = {};
        if (!authData["PR"][element.abrevModulo][element.assunto])
          authData["PR"][element.abrevModulo][element.assunto] = {};
        authData["PR"][element.abrevModulo][element.assunto] = element.valor 
      });

      this.loggedIn.next(true);  

      authService.setSession(authData);
    })
  }

  getLoggedUserName() {
    return this.loggedUserName;
  }

  getLoggedUserId() {
    return this.loggedUserId;
  }

  getLoggedUserType() {
    return this.loggedUserType;
  }

  get email() {
    return this.loggedUserEmail;
  }

  getLoggedEmpresaUser() {
    return this.loggedEmpresaUser;
  }

  getLoggedEmpresaNomeUser() {
    return this.getLoggedEmpresaNomeUser;
  }

  getTokenApp() {
    return this.tokenApp;
  }

  getTokenBackEnd() {
    return this.tokenBackEnd;
  }

  isActive() {
    return this.active;
  }

  getLoggedTime() {
    return this.loggedTime
  }

  getIsLoggedIn() {
    return this.loggedIn.getValue();
  }

  getLoggedUserRowid() {
    return this.rowidLoggedUser;
  }

  getModuloContratoHabilitado(): boolean {
    const parametro = this.getParametroGenerico("BAS", "ModuloContratoHabilitado");
    if (parametro === undefined)
      return false;
    else
      return JSON.parse(this.getParametroGenerico("BAS", "ModuloContratoHabilitado"));
  }

  getParametroGenerico(modulo: string, assunto: string){
    if(this.authData && this.authData["PR"]){
      if(this.authData["PR"][modulo]){
        if(this.authData["PR"][modulo][assunto]){
          return this.authData["PR"][modulo][assunto]
        }
      }
    }
    return undefined;
  }

  getParametroRelacao(assunto: string, nomeParametro:string)
  { 
    if(this.authData && this.authData["RG"]){
      if(this.authData["RG"][assunto]){
        if(this.authData["RG"][assunto][nomeParametro]){
          return this.authData["RG"][assunto][nomeParametro];      
        }
      }
    }
    return undefined;
  }

  setTokenBackEnd(value:string){
    this.tokenBackEnd = value;
  }

  public get isLoggedIn() {
    this.loggedIn.next(this.getSession());
    return this.loggedIn.asObservable();
  }

  invalidateSession() {
    localStorage.removeItem(this.jwtTokenName);
    this.tokenApp = undefined;
    this.tokenBackEnd = undefined;
    this.loggedIn.next(false);
  }

  logout(urlRedirect: string="",indVerificaUrlAtual: boolean = false) {
    localStorage.removeItem(this.jwtTokenName);
    localStorage.removeItem(this.jwtTokenMenu);
    this.storage.clear();
    this.tokenApp = undefined;
    this.tokenBackEnd = undefined;
    this.loggedIn.next(false);
    
    if (indVerificaUrlAtual)
      urlRedirect = this.router.url; 

    urlRedirect = urlRedirect.substring(1).trim();  

    if (urlRedirect && !urlRedirect.includes("sign-in"))
    {
      var urlAux = this.aesService.encrypt(urlRedirect);
      urlAux = encodeURIComponent(urlAux);
      this.router.navigateByUrl(`/public/sign-in?p=${urlAux}`);
      
    }
    else
      this.router.navigate(["/public/sign-in"]);
      
  }

  validaSessao(authRequest: AuthRequest, authData: AuthData): boolean | undefined {

    const helper = new JwtHelperService();
    var token = helper.decodeToken(authData.tokenBackEnd ?? "");

    if (authRequest.user != authData.loginUsuario || authRequest.user != token.userId) {
      this.snackBar.openSnackBar("Acesso Inválido", null, "Error");
      this.logout("",true);
      return;
    }

    return true;
  }

  isTokenExpired(token?: string): boolean | undefined {
    if (!token) token = localStorage.getItem(this.jwtTokenName) as string;
    if (!token) return true;

    if (environment.production) {
      try {
        token = this.aesService.decrypt(token);
      }
      catch (error) {
        return true;
      }
    }
    else if (!this.IsJsonString(token)) {
      this.snackBar.openSnackBar("Sessão Inválida!", "error");
      this.logout("",true);
      return;
    }

    this.authData = JSON.parse(token as string);
    var data = new Date();
    var dataValidade: Date | undefined = undefined;
    if (this.authData.dataHoraValidade!=null)
      dataValidade = new Date(this.authData.dataHoraValidade);

    return (dataValidade === undefined || data.getTime() > dataValidade.getTime()); //Verificar Aqui

  }

  private setSession(authData: AuthData) {
    var token: string = JSON.stringify(authData);
    if (environment.production) {
      token = this.aesService.encrypt(token);
    }
    localStorage.setItem(this.jwtTokenName, token);
    this.loggedUserName = authData.nomeUsuario;
    this.loggedUserId = authData.codigoUsuario;
    this.loggedUserType = authData.indTipoUsuario;
    this.loggedTime = authData.dataHoraLogin;
    this.tokenApp = authData.tokenApp;
    this.tokenBackEnd = authData.tokenBackEnd;
    this.loggedUserEmail = authData.emailUsuario;
    this.rowidLoggedUser = authData.rowid;
    this.loggedIn.next(true);
  }

  private getSession(): boolean {
    var token: string = localStorage.getItem(this.jwtTokenName) as string;
    if (!token) return false;

    if (environment.production) {
      try {
        token = this.aesService.decrypt(token);
      }
      catch (error) {
        return false;
      }
    }
    else if (!this.IsJsonString(token)) {
      this.snackBar.openSnackBar("Sessão Inválida!", "error");
      this.logout("",true);
      return false;
    }

    if (!token) {
      return false;
    }
    this.authData = JSON.parse(token);
    if ( this.authData ){
      return true;
    }
    else {
      return false;
    }
  }

  renewToken() {
    var token: string = localStorage.getItem(this.jwtTokenName) as string;

    if (environment.production) {
      try {
        token = this.aesService.decrypt(token);
      }
      catch (error) {
        this.snackBar.openSnackBar("Sessão Inválida!", "error");
        this.logout("",true);
        return;
      }
    }
    else if (!this.IsJsonString(token)) {
      this.snackBar.openSnackBar("Sessão Inválida!", "error");
      this.logout("",true);
      return;
    }

    var authData = new AuthData(JSON.parse(token));
    authData.dataHoraValidade = new Date(new Date().getTime() + environment.timeout);
    if (this.tokenBackEnd) {
      authData.tokenBackEnd = this.tokenBackEnd;
    }
    this.setSession(authData);
  }

  buscaEstruturaMenu() {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "bas/acesso/menu.p";
    request.procedure = "pi-monta-estrutura-menu";
    return this.http.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  setEstruturaMenu(estruturaMenu: MenuItemButton[]) {
    var token: string = JSON.stringify(estruturaMenu);
    if (environment.production) {
      token = this.aesService.encrypt(token);
    }
    localStorage.setItem(this.jwtTokenMenu, token);
  }

  retornaEstruturaMenu(): MenuItemButton[] | undefined {
    var tokenMenu: string = localStorage.getItem(this.jwtTokenMenu) as string;
    if (tokenMenu) {
      if (environment.production) {
        try {
          tokenMenu = this.aesService.decrypt(tokenMenu);
        }
        catch {
          this.snackBar.openSnackBar("Estrutura do Menu Incorreta!", "error");
          this.logout("",true);
          return;
        }
      }
      else {
        if (!this.IsJsonString(tokenMenu)) {
          this.snackBar.openSnackBar("Estrutura do Menu Incorreta!", "error");
          this.logout("",true);
          return;
        }
      }
      return JSON.parse(tokenMenu);
    }
  }


  private IsJsonString(str: string) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
}